var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 144"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 89",
    cx: 6,
    cy: 6,
    r: 6,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 76",
    d: "M3.36267 5.41741L4.52785 7.35938L9.18856 4.64062",
    stroke: "#4374FB",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTick);
export default __webpack_public_path__ + "static/media/circleTick.d257acda313a7a689bd62a2e1ceed320.svg";
export { ForwardRef as ReactComponent };